import { gql } from '@apollo/client';

const ORDER_ITEM_PROVISIONING_RESULT = gql`
  fragment BaseOrderItemProvisioningResultFragment on OrderItemProvisioningResult {
    orderItem {
      id
      product {
        id
        type
      }
    }
    dateExpiration
    licenseCount
  }
`;

export default ORDER_ITEM_PROVISIONING_RESULT;
